import type { InvoicingStatus } from '@numeo/types-main-web-app'

const TONE: Record<InvoicingStatus, string> = {
    missing_pod: 'bg-default text-foreground-muted',
    needs_review: 'bg-warning-soft text-warning-soft-foreground',
    ready: 'bg-success-soft text-success-soft-foreground',
    draft: 'bg-accent-soft text-accent-soft-foreground',
    batch_prepared: 'bg-accent-soft text-accent-soft-foreground',
    sent: 'bg-success-soft text-success-soft-foreground',
    other: 'bg-warning-soft text-warning-soft-foreground',
}

interface InvoicingStatusBadgeProps {
    status: InvoicingStatus
    label: string
}

/** A row's status word in its tone. The label is the one `badgeLabelOf` gives, so the table and the drawers read the same. */
export const InvoicingStatusBadge = ({ status, label }: InvoicingStatusBadgeProps) => (
    <span className={`inline-flex items-center rounded-md px-2 py-0.5 text-xs font-medium whitespace-nowrap ${TONE[status]}`}>{label}</span>
)
